export default {
  selectedGroup: "Itsinda Ryahiswemo",
  userFallback: "Ukoresha Sisitemu",
  welcome: "Murakaza neza, {name}",
  roleLabel: "Inshingano",
  adminArea: "Aho Ubuyobozi Bukorera",
  switchSection: "Hindura Aho Ukorera",
  backToMember: "Subira Aho Umunyamuryango Akorera",
  actions: {
    openMenu: "Fungura meni",
    closeMenu: "Funga meni",
    logout: "Sohoka",
  },
  roles: {
    owner: "Nyir’Itsinda",
    admin: "Umuyobozi",
    treasurer: "Umubitsi",
    member: "Umunyamuryango",
  },
};
